<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<form #form="ngForm" [formGroup]="householdService.searchForm" class="form-field-full">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>search</mat-icon> Search Households/Housing Units
      </h2>
    </div>
  </div>
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>OHA Id</mat-label>
              <input id="id" name="id" formControlName="id" matInput />
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Contact</mat-label>
              <input id="contactName" name="contactName" formControlName="contactName" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard" style="width:100%;">
              <mat-label>Address</mat-label>
              <input id="address1" name="address1" formControlName="address1" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>City</mat-label>
              <input id="city" name="city" formControlName="city" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Zip</mat-label>
              <input id="zip" name="zip" formControlName="zip" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>County</mat-label>
              <mat-select id="county" name="county" formControlName="county">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>


      </mat-card>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="infantsInHousehold"> Infants (2 and Under) In Household</mat-checkbox>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="age15AndBelow"> Age 15 And Below</mat-checkbox>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="age16AndAbove"> Age 16 And Above</mat-checkbox>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="pregnancyInHousehold"> Pregnancy In Household</mat-checkbox>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <br />
            <mat-checkbox formControlName="waterTreamentProvided"> Water Treatment Provided</mat-checkbox>
          </div>
        </div>

      </mat-card>
    </div>
  </div>

  <!-- buttons -->
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        &nbsp;&nbsp;
        View Results By:&nbsp;&nbsp;
        <mat-radio-group aria-label="View Results By" formControlName="searchBy">
          <mat-radio-button value="Household">Household</mat-radio-button>
          <mat-radio-button value="HousingUnits">Housing Units</mat-radio-button>
        </mat-radio-group>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonSearch" (click)="onSubmit()" mat-raised-button color="primary" title="Search" [disabled]='processing'>Search</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear" [disabled]='processing'>Clear</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonDownload" (click)="download()" mat-raised-button color="accent" title="Export Search Results"
          [disabled]='!showResults || processing || authService.isReadOnly()'>Export Search Results</button>
        &nbsp;&nbsp;
        <button type="submit" id="mergeButton" (click)="openMergeDialog()" mat-raised-button color="warn" title="Merge"
          [disabled]='!showResults || processing || searchResultsCount <= 0 || checkboxActionList.length <= 1 || authService.isReadOnly()'>
          <mat-icon class="icon-20">merge_type</mat-icon> Merge
        </button>
      </mat-card>
    </div>
  </div>
</form>

<!-- results -->
<mat-card [hidden]="!showResults">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{searchResultsCount}}) </strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Results ({{searchResultsCount}}) </mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="selectRow">
        <mat-header-cell *matHeaderCellDef fxFlex="4" fxFlex.lt-sm="100">&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="4">
          <input type="checkbox" (click)="clickCheckboxAction(result.id)" />
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="8" fxFlex.lt-sm="100">
          <span *ngIf="householdService.search.searchBy == 'Household'">OHA <br /> Household <br /> Id</span>
          <span *ngIf="householdService.search.searchBy == 'HousingUnits'">OHA <br /> Housing <br /> Unit Id</span></mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="8" fxFlex.lt-sm="100">
          <a [routerLink]="['/households/edit/', result.id]" title="Edit Household {{result.id}}" *ngIf="householdService.search.searchBy == 'Household'">{{result.id}}</a>
          <a [routerLink]="['/housingunit/edit/', result.id]" title="Edit Housing Unit {{result.id}}" *ngIf="householdService.search.searchBy == 'HousingUnits'">{{result.id}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="contactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Contact</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.contactName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="address1">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="100">Address</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15" fxFlex.lt-sm="100">
          {{result.address1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.city}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="zip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.zip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="county">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.county}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="waterTreamentProvided">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Water <br /> Treament <br /> Provided</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span *ngIf="result.waterTreamentProvided">Yes</span>
          <span *ngIf="!result.waterTreamentProvided">No</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="bottledWaterProvided">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Bottled <br /> Water <br /> Provided</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span *ngIf="result.bottledWaterProvided">Yes</span>
          <span *ngIf="!result.bottledWaterProvided">No</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="personsInHousehold">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Persons In <br /> Household</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.personsInHousehold}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="numberOfHouseholds">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Associated <br />Households</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.numberOfHouseholds}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="score">
        <mat-header-cell *matHeaderCellDef mat-sort-header>% Match</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.score}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>